<template>
    <section v-if="hasEvidence" aria-labelledby="library-archive-title" class="mt-6">
        <h3 id="library-archive-title" class="text-sm font-extrabold text-foxy-text">Архівні дані</h3>
        <div class="mt-3 rounded-2xl border border-dashed border-foxy-border bg-foxy-surface/45 p-4">
            <ul v-if="sessions.length" class="space-y-2 text-xs text-foxy-text-secondary">
                <li v-for="session in sessions" :key="`archive-session-${session.id}`" class="flex flex-wrap gap-x-2">
                    <template v-if="sessionHasDetails(session)">
                        <span v-if="session.read_at">{{ session.read_at }}</span>
                        <span v-if="session.language"
                            ><span v-if="session.read_at" aria-hidden="true">· </span>{{ resolvedLanguage(session.language) }}</span
                        >
                    </template>
                    <span v-else>Архівний запис без деталей.</span>
                </li>
            </ul>
            <p v-if="archiveCountCopy" :class="{ 'mt-3': sessions.length }" class="text-xs text-foxy-text-secondary">
                {{ archiveCountCopy }}
            </p>
        </div>
    </section>
</template>

<script lang="ts">
export default {
    name: 'LibraryArchiveEvidence',
    props: {
        archive: { type: Object, default: null },
        languageLabel: { type: Function, required: true },
    },
    computed: {
        sessions() {
            return this.archive?.reading_sessions || [];
        },
        remainingCount() {
            return Number(this.archive?.completed_read_count_claim?.remaining_unmaterialized_count || 0);
        },
        archiveCountCopy() {
            if (this.remainingCount <= 0) return '';
            if (this.archive?.completed_read_count_claim?.affects_compatibility_count === true) {
                return `Ще ${this.remainingCount} ${this.readingCountLabel(this.remainingCount)} з імпортованої історії без деталей`;
            }
            return `В імпортованих даних вказано кількість прочитань — ${this.remainingCount}, але її не вдалося підтвердити.`;
        },
        hasEvidence() {
            return this.sessions.length > 0 || this.remainingCount > 0;
        },
    },
    methods: {
        resolvedLanguage(language) {
            return this.languageLabel(language.code) || language.label || String(language.code || '').toUpperCase();
        },
        sessionHasDetails(session) {
            return Boolean(session?.read_at || session?.language);
        },
        readingCountLabel(count) {
            const mod100 = count % 100;
            const mod10 = count % 10;
            if (mod100 >= 11 && mod100 <= 14) return 'прочитань';
            if (mod10 === 1) return 'прочитання';
            if (mod10 >= 2 && mod10 <= 4) return 'прочитання';
            return 'прочитань';
        },
    },
};
</script>
